<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H16V16H0V0ZM12.6667 1.33333H14.6667V14.6667H12.6667L12.6667 1.33333ZM11.3333 1.33333H4.66667L4.66667 14.6667H11.3333L11.3333 1.33333ZM3.33333 14.6667L3.33333 1.33333H1.33333V14.6667H3.33333Z" fill="currentColor" />
</svg>
